<template>
  <div class="groups" :class="{blocked: blocked}">
    <Elements
      v-for="group in groups"
      :key="group.value"
      :group="group"
      :elements="elements"
    />
  </div>
</template>

<script>
    import Elements from "./Elements.vue";

    export default {
        components: {
            Elements
        },
        props: {
            groups: null,
            elements: null,
            blocked: null
        },
        computed: {
        }

    };
</script>

<style lang="less" scoped>
    .blocked {
        opacity: 0.4;
    }
</style>
